import type { TourStep } from '../types';

export const designImportSteps: TourStep[] = [
  {
    target: '[data-tour="design-import-modal"]',
    title: 'Массовый импорт дизайнов',
    content: 'Этот инструмент позволяет загрузить несколько дизайнов одновременно. Следуйте инструкциям для корректного импорта.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-upload"]',
    title: 'Загрузка файлов',
    content: 'Перетащите файлы сюда или нажмите для выбора. Поддерживаются форматы: PDF, PNG, JPG. Максимум 100 файлов за раз.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-naming"]',
    title: 'Правила именования',
    content: 'Имя файла должно содержать номер темы. Пример: "1234_бренд_тип.pdf". Система извлечёт метаданные из имени.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-preview"]',
    title: 'Предпросмотр',
    content: 'После загрузки вы увидите список файлов с превью. Проверьте корректность распознанных данных.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-metadata"]',
    title: 'Общие метаданные',
    content: 'Укажите общие данные для всех импортируемых дизайнов: бренд, тип, категорию. Можно изменить индивидуально.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-validate"]',
    title: 'Валидация',
    content: 'Система проверит файлы на дубликаты и ошибки. Файлы с проблемами будут отмечены красным.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-submit"]',
    title: 'Запуск импорта',
    content: 'Нажмите "Импортировать" для начала процесса. Импорт выполняется в фоновом режиме — вы можете продолжить работу.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-import-progress"]',
    title: 'Прогресс',
    content: 'Следите за статусом импорта в уведомлениях. После завершения вы получите отчёт об успешных и проблемных файлах.',
    placement: 'top',
    disableBeacon: true,
  },
];
